import { optimizePeaks } from 'ml-gsd';
import { convertWidthToHz } from '../peaks/util/convertWidthToHz';
import { convertWidthToPPM } from '../peaks/util/convertWidthToPPM';
export function xyPeaksOptimization(data, peaks, options) {
    const { frequency } = options;
    const newPeaks = convertWidthToPPM(peaks, { frequency });
    const optimizedPeaks = optimizePeaks(data, newPeaks, options);
    return convertWidthToHz(optimizedPeaks, {
        frequency,
        output: optimizedPeaks,
    });
}
//# sourceMappingURL=xyPeaksOptimization.js.map